module.exports = __webpack_public_path__ + "img/action-icon.c889c727.svg";